module.exports = __webpack_public_path__ + "static/media/hokage.2c3d1a03.webp";